var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDollarIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 11.2188C9.15625 12.75 7.84375 13.75 6 13.9688V15C6 15.5625 5.53125 16 5 16C4.4375 16 4 15.5625 4 15V13.9375C3.96875 13.9062 3.96875 13.9375 3.9375 13.9062C3.125 13.8125 2.28125 13.5 1.5 13.25L1.15625 13.125C0.65625 12.9375 0.375 12.375 0.53125 11.875C0.71875 11.3438 1.28125 11.0625 1.8125 11.25L2.15625 11.3438C2.84375 11.5938 3.59375 11.8438 4.21875 11.9375C5.71875 12.1562 7.28125 11.9062 7.46875 10.875C7.625 9.96875 7.09375 9.625 4.71875 8.96875L4.25 8.84375C2.875 8.46875 0.03125 7.65625 0.53125 4.78125C0.8125 3.28125 2.125 2.28125 4 2.0625V1C4 0.46875 4.4375 0 5 0C5.53125 0 6 0.46875 6 1V2.09375C6 2.125 6 2.09375 6.03125 2.125C6.5625 2.1875 7.15625 2.34375 7.9375 2.59375C8.4375 2.78125 8.71875 3.34375 8.5625 3.875C8.375 4.375 7.8125 4.65625 7.3125 4.5C6.65625 4.28125 6.125 4.15625 5.71875 4.09375C4.28125 3.875 2.6875 4.125 2.5 5.15625C2.375 5.90625 2.65625 6.3125 4.78125 6.90625L5.25 7.0625C7.125 7.5625 9.9375 8.34375 9.4375 11.2188Z",
    fill: "#8D9EAF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDollarIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dollar-icon.1d8884b5c0c9db22dca01cbdefbecf61.svg";